module.exports = __webpack_public_path__ + "static/media/rj_result_city4.1cd03496.png";